import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { ShiftOptions } from 'models/ICattlesData'
import {
	IMilkingProcessDeviationResponse,
	MilkingProcessDeviationType,
} from 'models/MilkingProcess'
import MilkingProcessService from 'services/milkingProcessService'

export interface UseGetMilkingProcessDeviationListOptions {
	enabled?: boolean
}

export const useGetMilkingProcessDeviationList = (
	startDate: number,
	endDate: number,
	shiftPeriod: ShiftOptions[] | 'all',
	page: number,
	pageSize: number,
	parlorId?: number[] | 'all',
	milkerId?: number[] | 'all',
	deviationType?: MilkingProcessDeviationType[] | 'all',
	ordering?: string[] | null,
	options?: UseGetMilkingProcessDeviationListOptions,
) => {
	const enabled = options?.enabled ?? true

	const { data, refetch, isError, isLoading, error } = useQuery<
		IMilkingProcessDeviationResponse,
		AxiosError
	>({
		queryKey: [
			'milking-process-deviation-list',
			startDate,
			endDate,
			shiftPeriod,
			page,
			pageSize,
			parlorId,
			milkerId,
			deviationType,
			ordering,
		],
		enabled,
		queryFn: async () => {
			const response = await MilkingProcessService.getMilkingProcessDeviations(
				startDate,
				endDate,
				shiftPeriod,
				page,
				pageSize,
				parlorId,
				milkerId,
				deviationType,
				ordering,
			)
			return response
		},
		staleTime: 50000,
		retry: 3,
		refetchOnMount: false,
	})

	return {
		data,
		isLoading,
		isError,
		error,
		refetch,
	}
}
